const storageLocaleKey = "locale";
export {
  storageLocaleKey
};
//# sourceMappingURL=types.js.map
